/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { injectable, inject } from 'inversify';
import HttpClient from './http.service';

@injectable()
export default class AdRegistrationService {
  @inject(HttpClient)
  protected http!: HttpClient;

  async signup() {
    try {
      const res = await this.http.post('/shop/want-join');
      return res;
    } catch (error) {
      return error;
    }
  }
}
